<template>
  <!--
      作者 gmshop
      时间：2019-10-26
      q区域树
  -->
  <div class="product-add" >
      <div v-loading="loading">
        <!-- <div class="gray9">搜索：Ctrl+F 键 ，输入搜索内容，则可找到相应内容 (1、存在区域代理会自动展开 2、必须展开才能搜索到)</div>
        <div class="gray9">默认展开的则存在区域代理</div>
        <div class="gray9">注意：该结构不会及时更新，缓存时间1个小时</div> -->
        <div class="gray9">注意：前端选择城市只能选择开启的城市</div>
        <div class="common-form">开启哪些城市（选择城市会展开下一级）</div>

        <el-tree
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(255, 255, 255, 0.8)"
          empty-text=""
          :data="province_list"
          node-key="id"
          default-expand-all
          @node-drop="handleDrop"
          @node-click="handleClick"
          draggable
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          ref="tree"
        >
          <span class="custom-tree-node"  style=" width: 100%; " slot-scope="{ node, data }">
            <span class="m30">{{ data.name }}</span>
          <a style="margin-left: 40px;" v-if="data.status==1" v-on:click="setting(data.id,data.level)">设置</a>
   <!--
            <a v-if="data.level==1 && data.status==1 && data_setting != 1" style="margin-left: 20px;" 
            v-on:click="sync(data.id,data.level)">同步数据</a> -->
            <el-switch style="margin-left: 20px;" :key="data.id"  v-model="data.status" 
            :active-value="1"
            :inactive-value="0"
            @change="isDefaultChange(data.id,data.level,data.status)"></el-switch>
            
            <div style="clear: both;"></div>
          </span>
        </el-tree>
      </div>

      <Setting v-if="open_add" :open_add="open_add" :obj="obj" @closeDialog="closeProductDialogFunc($event)"> </Setting>
  </div>

</template>

<script>
import CityApi from '@/api/city.js';
  import Setting from './setting';
  export default {
    components:{
      Setting
    },
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        data: [],
        defaultProps: {
          children: 'child',
          label: 'name'
        },
        region_ids:[],
        params:{
          id: 0,
          type: 0,
        },
        province_list: [],
        flag:true,
        open_add:false,
        obj:{
          level:1,
          id:0
        },
        data_setting:1,//1 未选中  2  企业总数   3  人口总数
      };
    },
    created() {
      this.getParams()
    },

    methods: {
      sync(id,level){
        var self = this;
        let params = self.params;
        params.id = id;
        params.level = level;
        self.flag = false;
        params.data_setting = self.data_setting
        CityApi.sync_district(params, true).then(res => {
          if(res.code == 1){
                self.$message({
                message:res.msg,
                type: 'success'
              });

            }else{
              self.$message({
                message:res.msg,
                type: 'success'
              });

            }
          
          setTimeout(function(){
              self.flag = true;
            },350)
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
        
        
      },
      isDefaultChange(id,level,status){
        var self = this;
        let params = {
          id:id,
          level:level,
          status:status?1:0,
        }
        this.flag = false;
        CityApi.open(params, true).then(res => {
            console.log(res)
            if(res.msg == "开启成功"){
                self.$message({
                message:"设置成功",
                type: 'success',
              });
              self.flag = true;
              setTimeout(function(){
                  self.handleClick({
                  id:id,
                  type:level,
                  level:level,
                  end:0
                })
              },500)
              
            }else{
              self.flag = true;
                self.$message({
                message: res.msg,
                type: 'error'
              });
            }
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });

       

      },
      /*关闭弹窗*/
      closeProductDialogFunc(e) {
            this.open_add = e.openDialog;

      },
      /*获取配置数据*/
      getParams(node) {
        let self = this;
        let params = self.params;
        CityApi.getTree(params, true).then(res => {
            self.data_setting = res.data.data_setting
            if (self.params.id>0 && self.params.type>0){
              console.log(res.data.list)
              self.append(node, res.data.list);
            } else {
              self.province_list = res.data.list;
            }  
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
      },

      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      setting(id,level){
        var self = this;
        console.log("id:",id)
        console.log("level:",level)
        this.flag = false;
        this.obj = {
          level:level,
          id:id
        }
        this.open_add = true;
        setTimeout(function(){
          self.flag = true;
        },350)
      },
      // 点击
      handleClick(e){
        if(this.flag){
          this.params.id = e.id;
          this.params.type = e.level;
          if(e.level>3){
            return false;
          }
          if (!e.children && e.end==0){
            this.getParams(e);
          }
        }
    
      },
    

      // 增加
      append(data, children_data) {
        if (!children_data.length) data.end = 1;
        children_data.forEach(e => {
          if (!data.children) {
            this.$delete(data, 'children')
            this.$set(data, "children", []);
          }
          data.children.push(e);
        });
        this.$forceUpdate();
      },

      remove(node, data) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex((d) => d.id === data.id);
        children.splice(index, 1);
      },
      renderContent(h, { node, data, store }) {
        return (
          <span class="custom-tree-node">
            <span>{node.label}</span>
            <span>
              <el-button
                size="mini"
                type="text"
                on-click={() => this.append(data)}
              >
                Append
              </el-button>
              <el-button
                size="mini"
                type="text"
                on-click={() => this.remove(node, data)}
              >
                Delete
              </el-button>
            </span>
          </span>
        );
      },
      handleDrop(draggingNode, dropNode, dropType, ev) {
        console.log("tree drop: ", dropNode.label);
      },
    }
  };
</script>
<style>
  .tips {
    color: #ccc;
  }
  .custom-tree-node {
    flex: 1;
   
    
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .el-tree-node__content{
    height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/city/index/index.vue